module.exports = __webpack_public_path__ + "static/homepage-button-patient-811c8be0040f0d7e7423a4771824dc35.png";